import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class TextField extends React.Component
{
    static propTypes = {
        id: PropTypes.string.isRequired,
        type: PropTypes.string,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        help: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        hint: PropTypes.string,
        error: PropTypes.bool,
    };

    static defaultProps = {
        label: '',
        type: 'text',
        placeholder: '',
        help: '',
        hint: '',
        error: false,
    };

    render()
    {
        const {
            id,
            label,
            placeholder,
            help,
            hint,
            error,
            className,
            ...otherProps
        } = this.props;

        const inputClasses = classNames({
            [className]: !! className,
            'shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md': true,
            'border border-red-500': error
        });

        const labelClasses = classNames({
            'flex justify-between text-gray-700': true,
            'text-red-500': error
        });

        return <div>
            <div className={labelClasses}>
                { label && <label htmlFor={id} className="block text-sm font-medium leading-5">{label}</label>}
                { hint && <span className="text-sm leading-5 text-gray-500">{hint}</span> }
            </div>
            <div className="relative rounded-md shadow-sm">
                <input id={id} className={inputClasses} placeholder={placeholder} {...otherProps} />
            </div>
            { this.renderHelpMessage(help) }
        </div>;
    }

    renderHelpMessage(help)
    {
        if (! help) {
            return null;
        }

        const message = Array.isArray(help) ? help[0] : help;

        const helpClasses = classNames({
            'mt-2 text-sm text-gray-500': true,
            'text-red-500': true
        });

        return <p className={helpClasses}>{message}</p>;
    }
}
